import React, { useState, useEffect } from 'react';
// @material-ui/core components
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Pagination from '@material-ui/lab/Pagination';
import { makeStyles } from '@material-ui/core/styles';
// core components
import { connect } from 'react-redux';
import {
  getMenus as getCategoryList,
  getOrderList,
  getAllDeliveryBoys
} from '../../store/actions/admin/Admin';
import CardHeader from '../../components/Card/CardHeader.js';
import OrderItemCard from '../../components/Common/OrderItemCard.js';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { ORDER_STATUS_DRIVER as ORDER_STATUS } from '../../utils/constant.js';
import BackDrop from '../../components/User/Preloader/BackDrop';
import GlobalSearch from '../../components/Common/GlobalSearch';

const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);
const PAGE_LIMIT = 2000
var update = false;
const OrdersTableList = (props) => {
  const classes = useStyles();
  const api_progress = props.api_progress
  const [pageNo, updatePageNo] = useState(1)
  const [searchText, setSearchText] = useState('');
  useEffect(() => {
    // props.getCategoryList();
    props.getOrderList(-1, pageNo);
    props.getAllDeliveryBoys();
  }, [update]);
  const { className } = props;
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [orderStatus, updateStatus] = useState(-1);

  const toggle = () => setModal(!modal);
  const toggle2 = () => setModal2(!modal2);

  const [itemDelete, setItemDelete] = useState(0);

  const handleDelete = (menuId) => {
    props.deleteMenu(menuId);
    if (update === false) {
      update = true;
      setTimeout(() => {
        update = false;
      }, 2500);
    } else {
      update = true;
      update = false;
    }
  };

  const handleChangeOrderStatus = (e) => {
    props.getOrderList(e.target.value).then((data) => {
      if (data) {
        updateStatus(e.target.value);
      }
    });
  };

  const handlePagination = (e, page) => {
    updatePageNo(page)
    props.getOrderList(orderStatus, page);
  }
  const handleSearchSubmit = () => {
    props.getOrderList(orderStatus, undefined, searchText);
  }
  return (
    <>
      <BackDrop open={api_progress}></BackDrop>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>All Orders</h4>
        <FormControl className={classes.formControl}>
          <InputLabel id="demo-controlled-open-select-label">Status</InputLabel>
          <Select
            labelId="demo-controlled-open-select-label"
            id="demo-controlled-open-select"
            value={orderStatus}
            onChange={handleChangeOrderStatus}
          >
            {ORDER_STATUS?.map((item) => (
              <MenuItem value={item?.value}>{item?.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <br></br>
        <FormControl className={classes.formControl}>
          <GlobalSearch width={'500px'} onChange={(event) => {
            setSearchText(event.target.value)
          }}
            title={"Search Order By Order Ref No"}
            handleSubmit={handleSearchSubmit}
          />
        </FormControl>
      </CardHeader>
      <div style={{ marginTop: '20px' }}>
        {props?.orderList?.map((item) => (
          <OrderItemCard
            id={item.id}
            drivers={props.drivers}
            vendor={item?.vendorDetails[0]}
            address={item?.address}
            orderRef={item?.orderRef}
            user={item?.userDetails[0]}
            image={item?.vendorDetails[0]?.logo}
            isDriver={true}
            driver={item?.driver}
            date={item?.createdAt}
            items={item?.orderDetails}
            price={item?.totalPrice}
            status={item.status}
            order={item}
          />
        ))}
      </div>
      <br></br>
      <br></br>
      <Pagination
        count={props.orderCount ? Math.ceil(props.orderCount / 10) : 1}
        color="primary"
        page={pageNo}
        onChange={handlePagination}
      />
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>Delete</ModalHeader>
        <ModalBody>Do you really want to delete this Menu??</ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modal2} toggle={toggle2} className={className}>
        <ModalHeader toggle={toggle2}>Modify a Menu</ModalHeader>
        <ModalBody></ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle2}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

const mapStateWithProps = (state) => ({
  menuItems: state.admin.menuItems,
  orderList: state.admin.orderList,
  orderCount: state.admin.orderCount,
  api_progress: state.admin.apiLoading,
  drivers: state.admin.allDrivers,
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getCategoryList: () => dispatch(getCategoryList()),
    getAllDeliveryBoys: () => dispatch(getAllDeliveryBoys(1, PAGE_LIMIT)),
    getOrderList: (id, pageNumber, orderRef) => dispatch(getOrderList(id, pageNumber, orderRef))
  };
};

export default connect(
  mapStateWithProps,
  mapDispatchWithProps
)(OrdersTableList);
